import { z } from "zod";

export const ProductSchema = z.object({
  description: z.string().min(3, "Ingrese una descripción válida"),
  unit: z.string().min(1, "Ingrese una unidad válida"),
  location: z.string().optional(),
  stock: z.coerce.number().min(0, "Debe ser mayor o igual a 0"),
  minimumStock: z.coerce.number().min(0, "Debe ser mayor o igual a 0"),
  converter: z.coerce.number().min(0, "Debe ser mayor o igual a 0"),
  converterTypeId: z.string().optional(),
  storageId: z.string().min(1, "Ingrese un almacen válido"),
});

export const ProductStateSchema = z.object({
  data: ProductSchema,
  amount: z.number(),
  missingStock: z.number().optional(),
  price: z.number().optional(),
});

export type ProductFormInput = z.infer<typeof ProductSchema>;
